<template lang="html">
  <div class="col-12 col-xl-10 offset-xl-1 col-tab-2">
    <h5 class="tab-title">Coberturas</h5>

    <div class="d-block mt-3">
      <p>
        LA RED DE BLACKFON tiene una cobertura en el 70.70% de la población a través de infraestructura propia 4.5G y el resto del país de manera compartida por medio de otras redes disponibles.<br />
        Enlace donde se podrán encontrar la cobertura de BlackFon <a target="_blank" href="http://www.blackfon.online/#/cobertura">http://www.blackfon.online/#/cobertura</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
}
</script>
